import React, { Component } from 'react'
import {Link} from 'react-router-dom'
// import { REST_API } from '../../actions/constants'


export class DashboardTaskModal extends Component {

  state = {
    rowData: [],
    count: 0
  }

  componentDidMount() {
    let taskData = this.props.modalData
    if(this.props.modalId === 'Unnamed'){
      this.setState({
        rowData: taskData.filter( data => data.topic === null ),
        count: taskData.filter( data => data.topic === null ).length
      })
    } else {
      this.setState({
        rowData: taskData.filter( data => data.topic === this.props.taskTitle ),
        count: taskData.filter( data => data.topic === this.props.taskTitle ).length
      })
    }

    
    
  }
 
  renderTaskData = () => {

    if(this.state.rowData.length){
      let rowCount = 0
      return this.state.rowData.map( task => {
          rowCount++
        // if(task) {
          return (
            <div className="row" key={`${task.id}-${this.props.modalTitle}${Math.random()}`}>
              <div className="col-1 text-center">{rowCount}</div>
              <div className="col-4"><Link to={`/message-queues/${task.id}`} target="_blank">{task.name}</Link></div>
              {/* <div className="col-4"><Link to={`/message-queues/${task.id}`} target="_blank">{task.topic}</Link></div> */}
              <div className="col-7">{task.description}</div>
            </div>
          )
        // }
      })
    }
  } 
    
  
  // renderTaskTitleDescription = () => {
  //   let dynamicTitleDescription = ''
  //   let pluralTaskCount = this.props.taskCount > 1 ? 'tasks' : 'task'
  //   switch(this.props.modalTitle){
  //     case 'Completed':
  //       dynamicTitleDescription =`${this.props.modalTitle} running ${this.props.taskCount} ${pluralTaskCount}`
  //       break
  //     case 'Processing':
  //       dynamicTitleDescription =`Still ${this.props.modalTitle} ${this.props.taskCount} ${pluralTaskCount}`
  //       break
  //     case 'Failed':
  //       dynamicTitleDescription =`${this.props.modalTitle} running ${this.props.taskCount} ${pluralTaskCount}`
  //       break
  //     default:
  //       break
  //   }
  //   return dynamicTitleDescription
  // }

  disabledButton = () => {
    return this.props.currentSkip > 1 ? false : true
  }

 

  render() {
    return (
      <div>
        
        <div style={{zIndex: '25'}} className="modal fade" id={this.props.modalId} tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div className="modal-content">
                
              <div className="modal-header">
                <h6 className="modal-title" id="exampleModalLongTitle"><span className="string-label"><span className="badge badge-dark">Task Name</span> ► {this.props.taskTitle}</span></h6>
                
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className={`row ${(this.props.modalTitle === 'Completed') ? 'completed' : (this.props.modalTitle === 'Processing') ? 'processed' : 'failed'}`}>
                  
                  <div className="col-1 text-center text-white border-right border-white">#</div>
                  <div className="col-4 text-center text-white border-right border-white">Sub-task Name</div>
                  {/* <div className="col-4 text-center text-white border-right border-white">Topic</div> */}
                  <div className="col-7 text-center text-white">Description</div>
                </div>
              <div className="modal-body task-modal" style={{overflow: 'auto', maxHeight: '300px', paddingTop: 'unset'}}>
                
            
                    {this.renderTaskData()}
                 
              </div>
              <div className="modal-footer">
                <span
                  className="text-info pl-2">{this.state.count} item{this.state.count > 1? 's' : ''}
                </span>
                  <div className={`row  mx-auto ${this.props.taskCount > this.props.queryLimit ? '': 'd-none'}`}>
                    <div className="col-3">
                      <button type="button" className={`mr-5 btn btn-secondary`} onClick={() => this.props.handleFetchPrevData(this.props.modalTitle)} disabled={this.props.currentSkip > 1 ? false : true} >Prev {this.props.queryLimit}</button>
                    </div>
                    <div className="col-6">
                      <div className="row mx-auto">
                        <div className="col text-center">
                          {/* <form action="" onSubmit={(e) => this.props.handlePageSubmit(e, this.props.modalTitle)}> */}

                          {/* <span>Page </span><input className="col-4" type="text" value={this.props.currentSkip < Math.ceil(this.props.taskCount / this.props.queryLimit) ? this.props.currentSkip : Math.ceil(this.props.taskCount / this.props.queryLimit)} onChange={(e) => this.props.handleInput(e, this.props.modalTitle)} /> of {Math.ceil(this.props.taskCount / this.props.queryLimit)} */}


                          <span>Page </span>{this.props.currentSkip < Math.ceil(this.props.taskCount / this.props.queryLimit) ? this.props.currentSkip : Math.ceil(this.props.taskCount / this.props.queryLimit)} of {Math.ceil(this.props.taskCount / this.props.queryLimit)}


                          {/* <span>Page </span><input className="col-4" type="text" value={this.props.currentSkip < Math.ceil(this.props.taskCount / this.props.queryLimit) ? this.props.currentSkip : Math.ceil(this.props.taskCount / this.props.queryLimit)} onChange={(e) => this.props.handleInput(e, this.props.modalTitle)} disabled /> of {Math.ceil(this.props.taskCount / this.props.queryLimit)} */}


                          {/* </form> */}
                        </div>
                      </div>                  
                    </div>
                    <div className="col-3">
                      <button 
                        type="button"
                        className={`btn btn-secondary`}
                        onClick={() => this.props.handleFetchNextData(this.props.modalTitle)}
                        disabled={this.props.currentSkip < Math.ceil(this.props.taskCount / this.props.queryLimit) ? false : true}
                      >
                        Next {this.props.queryLimit}
                      </button>
                    </div>
                    
                  </div>
                
              </div> 
            </div>
          </div>
        </div>
      </div>
    )
  }

}

DashboardTaskModal.defaultProps = {
  modalTitle: 'Loading data',
  modalData: []
}

export default DashboardTaskModal



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardTaskModal.js